import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoriesService } from '../shared/category/categories.service';
import { Process } from '../shared';
import * as fromReminder from '.';
import { processResolver } from '../efaact-routing/process-resolver';

const log = new LoggingService();

export const ReminderRoute: Ng2StateDeclaration = {
    // name: 'Reminder.**'
    name: 'reminders',
    url: '/reminders',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.ReminderModule)
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: fromReminder.ReminderContainerComponent
};
